import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgDownloadIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.36 7.106 8.625 9.823V0h-1.25v9.794L4.746 7.112l-.892.875 3.7 3.775.44.45.446-.444 3.8-3.775-.88-.887ZM-.025 10.338v5.691h16.05v-5.493h-1.25v4.243H1.225v-4.441h-1.25Z",
    fill: "currentColor"
  }));
}

export { SvgDownloadIcon as default };
